// This implements the solution decribed : https://github.com/gatsbyjs/gatsby/issues/8560#issuecomment-535265414
// for MMW-91
const ReactDOM = require("react-dom");
export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
}
